import {Tag as PeacockTag} from '@pepsico-ds/ui'
import {TAG_COLOR} from '@/shared/constants/colors'
import {SIZE} from '@/shared/constants/globalStyle'
import PropTypes from 'prop-types'
/**
 * Tag component renders a tag with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to be displayed inside the tag.
 * @param {boolean} [props.isRemovable=false] - Whether the tag is removable; default is false.
 * @param {boolean} props.isCopyable - Whether the text is copyable; default is false.
 * @param {('blue'|'green'|'red'|'gray'|'orange'|'purple'|'default')} [props.color='blue'] props.color - The DS Tag color name (maps to .color-tag-*).
 * @param {string} [props.id=''] - Optional additional id to apply to the tag.
 * @param {Function} [props.onRemove] - Function to handle remove events.
 * @param {string} [props.size=SIZE.LARGE] - The size of the tag.
 * @param {Function} [props.onClick] - Function to handle click events.
 * @returns {JSX.Element} The rendered Tag component.
 */

const Tag = ({
  text, 
  isRemovable = false,
  isCopyable = false, 
  color = TAG_COLOR.AUXILIARY_600, 
  onRemove = () => {},
  id,
  size = SIZE.LARGE,
  onClick = () => {},
}) => {
  return (
    <span onClick={onClick} style={{cursor: 'pointer'}}>
      <PeacockTag 
        id={`tag` + (id ? `_${id}` : '')}
        data-testid={`tag` + (id ? `_${id}` : '')}
        text={text} 
        isCopyable={isCopyable} 
        color={color} 
        isRemovable={isRemovable}
        onRemove={onRemove}
        size={size}
      />
    </span>
  )
}

Tag.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isRemovable: PropTypes.bool,
  isCopyable: PropTypes.bool,
  color: PropTypes.string,
  onRemove: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.string,
  onClick: PropTypes.func,
}

export default Tag
